import PropTypes from 'prop-types';
import styles from './FJGeneratePrivacySettings.module.less';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip.jsx';
import FJPrivacySetting from '../../FJCommunity/FJCommonComponent/FJPrivacySetting/FJPrivacySetting.jsx';
import FJShareSettingIcon from '../../../assets/svg/community/publish.svg?react';

const FJGeneratePrivacySettings = props => {
    const { privacyStatus, onPrivacySettingChange, placement = 'topCenter' } = props;

    return (
        <FJPrivacySetting
            value={privacyStatus}
            onChange={onPrivacySettingChange}
            placement={placement}
            offsetTop={-4}
            hideShareToSociety={true}
            renderTrigger={({ ref, onClick }) => {
                return (
                    <FJToolTip title='visibility'>
                        <div className={styles.icon_box} ref={ref} onClick={onClick}>
                            <FJShareSettingIcon />
                        </div>
                    </FJToolTip>
                );
            }}
        />
    );
};

FJGeneratePrivacySettings.propTypes = {
    privacyStatus: PropTypes.string,
    onPrivacySettingChange: PropTypes.func,
};
export default FJGeneratePrivacySettings;
